import { useContext, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { DELETE } from "../../utils/fetchUtil";
import { getAccessToken } from "../authorization/AuthorizeService";
import { MessageContext } from "../message";
import "./ElectionFileUpload.scss";

const ElectionFileUpload = ({
  placeholder,
  isRequired,
  handleFile,
  name,
  electionState,
  dispatch,
  acceptDocx,
  setFetchCandidatesTrigger,
}) => {
  const { t } = useTranslation();
  const message = useContext(MessageContext);
  let allowedFileInputTypes;

  // Create a reference to the hidden file input element
  const hiddenFileInput = useRef(null);

  // Programatically click the hidden file input element
  // when the Button component is clicked
  const handleClickForUpload = () => {
    hiddenFileInput.current.click();
  };

  // Call a function to handle the uploaded file
  const handleFileInputChange = (e) => {
    const fileUploaded = e.target.files[0];

    let duplicateName = false;

    if (electionState[name]) {
      electionState?.documents?.forEach((doc) => {
        if (doc.name === fileUploaded.name) {
          duplicateName = true;
        }
      });
    }

    const fileSizeKiloBytes = fileUploaded.size / 1024;
    //File limit 5MB
    if (fileSizeKiloBytes > 5120) {
      message.toggle({
        title: "Napomena",
        content: "Veličina datoteke je ograničena na 5MB.",
        hideNo: true,
        yesLabel: t("modalMessage.okLabel"),
        onYes: () => {
          message.toggle({});
        },
      });
    } else if (duplicateName) {
      message.toggle({
        title: "Napomena",
        content: "Datoteka s ovim nazivom već postoji.",
        hideNo: true,
        yesLabel: t("modalMessage.okLabel"),
        onYes: () => {
          message.toggle({});
        },
      });
    } else {
      handleFile(fileUploaded);
    }
  };

  // Remove uploaded file, compared by name, if fileId exists, delete from server
  const handleDeleteUploadedFile = (rowIndex, fileId) => {
    if (fileId) {
      DELETE(
        "/candidateDocument?id=" + fileId,
        (response) => {
          let uploadedFiles = [];
          if (electionState[name]?.length > 0) {
            uploadedFiles = Array.from(electionState[name]);
          }
          uploadedFiles.splice(rowIndex, 1);
          dispatch({ type: "update", payload: { [name]: uploadedFiles } });
          setFetchCandidatesTrigger((prevState) => prevState + 10);
        },
        (error) => {
          message.toggle({
            title: t("requests.reviewDocuments.action.save.error"),
            content: error,
            hideNo: true,
            yesLabel: t("modalMessage.okLabel"),
            onYes: () => {
              message.toggle({});
            },
          });
        }
      );
    }
    // if fileId is null, file is not on server, local array delete only
    else {
      let uploadedFiles = [];
      if (electionState[name]?.length > 0) {
        uploadedFiles = Array.from(electionState[name]);
      }
      uploadedFiles.splice(rowIndex, 1);
      dispatch({ type: "update", payload: { [name]: uploadedFiles } });
    }
  };

  let inputParametars = {
    placeholder: "_placeholder",
    className: "election-input-txt",
    type: "text",
    name: name,
    readonly: "true",
  };

  const getFileFromServer = async (fileUrl) => {
    message.toggle({
      show: true,
      title: "",
      content: t("requests.wait.label"),
      hideNo: true,
      hideYes: true,
      isWait: true,
      hideX: false,
    });
    fetch(`${process.env.REACT_APP_GATEWAY_URL}${fileUrl}`, {
      method: "GET",
      headers: {
        "Request-Origin": "pisarnica",
        Authorization: "Bearer " + (await getAccessToken()),
      },
      mode: "cors",
      credentials: "include",
    })
      .then((response) => response.blob())
      .then((file) => window.open(URL.createObjectURL(file)) && message.toggle({ show: false }));
  };

  if (acceptDocx) {
    allowedFileInputTypes =
      "image/jpeg,image/png,application/pdf,.docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  } else {
    allowedFileInputTypes = "image/jpeg,image/png,application/pdf";
  }

  if (electionState) {
    return (
      <div className="floating-label-wrap">
        <input
          style={{ color: "transparent", cursor: "pointer" }}
          onClick={handleClickForUpload}
          {...inputParametars}
        />
        <input
          onChange={handleFileInputChange}
          ref={hiddenFileInput}
          style={{ display: "none" }}
          type={"file"}
          accept={allowedFileInputTypes}
        />
        <label
          className={
            electionState[name]?.length > 0
              ? "election-input-label is-size-4 file-upload-top-is-70"
              : "election-input-label is-size-4 file-upload-top-is-0"
          }
          typeof="text"
          htmlFor="input1"
        >
          {placeholder}
          {isRequired ? <span className="has-text-danger ml-1">*</span> : ""}
        </label>
        <div>
          {electionState[name]?.length === 1 ? "Prenesena datoteka:" : "Prenesene datoteke:"}
        </div>
        {electionState[name]?.length > 0 ? (
          <div className="has-text-left">
            {electionState[name]?.map((doc, index) => {
              const fileName = doc.fileUrl?.split("_user_")[1];
              return (
                <div
                  key={index}
                  className="is-flex is-justify-content-space-between uploaded-file-parent"
                >
                  {doc.name ? (
                    <div className="uploaded-file-name">{doc.name}</div>
                  ) : (
                    <div
                      onClick={() => {
                        getFileFromServer(doc.fileUrl);
                      }}
                      style={{ cursor: "pointer" }}
                      className="uploaded-file-name"
                    >
                      {fileName}
                    </div>
                  )}
                  <div
                    onClick={() => {
                      handleDeleteUploadedFile(index, doc.id);
                    }}
                    className="is-size-5 remove-uploaded-file-icon has-pointer-cursor"
                  >
                    Ukloni
                  </div>
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    );
  } else {
    return null;
  }
};

export default ElectionFileUpload;
